import styled from "styled-components";

export default styled.div`
  display: inline-block;
  background: #dadada;
  border: 5px solid #b3b3b3;
  border-top: 5px solid #efefef;
  border-left: 5px solid #efefef;
  width: 20px;
  height: 20px;
  text-align: center;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.7);
`;
